export class Track {
    closed;
    #points;
    #lengths;
    total;
    constructor(path, closed) {
        this.closed = closed;
        this.#points = closed ? [...path, path[0]] : path;
        this.#lengths = this.#points
            .slice(1)
            .map((p, i) => Math.hypot(p[0] - this.#points[i][0], p[1] - this.#points[i][1]));
        this.total = this.#lengths.reduce((sum, l) => sum + l, 0);
    }
    /** Where `distance` metres along is, and which way it heads (about y); written into `into`, nothing made. */
    at(distance, into) {
        const total = this.total;
        let d = this.closed
            ? ((distance % total) + total) % total
            : Math.min(Math.max(distance, 0), total);
        const lengths = this.#lengths;
        for (let i = 0; i < lengths.length; i++) {
            const a = this.#points[i];
            const b = this.#points[i + 1];
            if (d <= lengths[i] || i === lengths.length - 1) {
                const t = lengths[i] > 0 ? d / lengths[i] : 0;
                into.x = a[0] + (b[0] - a[0]) * t;
                into.z = a[1] + (b[1] - a[1]) * t;
                into.heading = Math.atan2(b[0] - a[0], b[1] - a[1]);
                return;
            }
            d -= lengths[i];
        }
        into.x = this.#points[0][0];
        into.z = this.#points[0][1];
        into.heading = 0;
    }
}
/** Where `distance` metres along the path is, and which way it heads (radians about y); a new object each call. */
export function routePoint(path, closed, distance) {
    const out = { x: 0, z: 0, heading: 0 };
    new Track(path, closed).at(distance, out);
    return out;
}
//# sourceMappingURL=track.js.map